export interface DesignTemplate {
  name: string;
  /** c4 — light page background */
  background: string;
  button: {
    /** c1 — buttons, borders, section titles */
    background: string;
    /** semantic — button label text (white or black) */
    text: string;
    border?: string;
  };
  card_style?: string;
  /** c3 — profile name, bio, post dates (tertiary mid-tone) */
  text: string;
  /** icon color: auto-derived (#000 on light bg, #FFF on dark bg) */
  socialIcon?: string;
  quaternary?: string;
}

export interface ColorSection {
  label: string;
  presets: string[];
}

export const COLOR_OPTION_SECTIONS: ColorSection[] = [
  {
    label: "Single-tones",
    presets: [
      "Default",
      "Lavender",
      "Matcha",
      "Terracotta",
      "Blueberry",
      "Pink",
      "Olive",
    ],
  },
  {
    label: "Neutrals",
    presets: [
      "Dark",
      "Bronze",
      "Tobacco",
      "Cream + Charcoal",
      "Grey",
    ],
  },
  {
    label: "Two-tones · Bold",
    presets: [
      "Honey + Tangerine",
      "Cream + Cobalt",
      "Pool + Cherry",
      "Lime + Ruby",
      "Periwinkle + Red",
      "Butter + Evergreen",
      "Cobalt",
      "Lime + Pine",
      "Hot Pink + Plum",
    ],
  },
];

/** Saved palette names from earlier catalogs → current COLOR_OPTIONS names. */
export const PALETTE_NAME_ALIASES: Record<string, string> = {
  "Cream + Coffee": "Cream + Charcoal",
  "Periwinkle + Scarlet": "Periwinkle + Red",
  "Butter + Emerald": "Butter + Evergreen",
};

/** Four design slots: page background, text & accents, muted text, surfaces. */
export function designTemplateSlots(t: DesignTemplate): {
  bg: string;
  accent: string;
  muted: string;
  surface: string;
} {
  return {
    bg: t.background,
    accent: t.button.background,
    muted: t.text || t.button.text,
    surface: t.card_style || t.background,
  };
}

export function getColorOptionsForSection(label: string): DesignTemplate[] {
  const section = COLOR_OPTION_SECTIONS.find((s) => s.label === label);
  if (!section) return [];
  return section.presets
    .map((name) => COLOR_OPTIONS.find((o) => o.name === name))
    .filter((o): o is DesignTemplate => Boolean(o?.background?.startsWith("#")));
}

// Color options used in DesignTab and DesignOptions components
export const COLOR_OPTIONS: DesignTemplate[] = [
  // {
  //   name: "Default",
  //   background: "#FFFFFF",
  //   button: { background: "#e6e7eb", text: "#000000", border: "" },
  //   text: "#000000",
  //   socialIcon: "#000000",
  //   card_style: "#ffffff"
  // },
  // {
  //   name: "Earthy Elegance",
  //   background: "#6B4F4F",
  //   button: { background: "#B4846C", text: "#FFFFFF" },
  //   text: "#F5EBDD", // soft beige instead of plain white
  //   socialIcon: "#F5EBDD",
  // },
  // {
  //   name: "Emerald Sea",
  //   background: "#1B4242",
  //   button: { background: "#5C8374", text: "#E0F2E9" },
  //   text: "#E0F2E9", // mint tint
  //   socialIcon: "#E0F2E9",
  // },
  // {
  //   name: "Galaxy Night",
  //   background: "#22223B",
  //   button: { background: "#9F73AB", text: "#F1D4E5" },
  //   text: "#EAD9F5", // lavender pink
  //   socialIcon: "#EAD9F5",
  // },

  // {
  //   name: "Forest Sage",
  //   background: "#065f46",
  //   button: { background: "#10b981", text: "#FEFCE8" },
  //   text: "#E2F8DF", // pale green tint, less yellow
  //   socialIcon: "#E2F8DF",
  // },
  // {
  //   name: "Mocha Cream",
  //   background: "#451a03",
  //   button: { background: "#d97706", text: "#FFF1E0" },
  //   text: "#F8E7C6", // warm cream
  //   socialIcon: "#F8E7C6",
  // },
  // {
  //   name: "Steel & Gold",
  //   background: "#475569",
  //   button: { background: "#94a3b8", text: "#FAE588" },
  //   text: "#FAE588", // soft gold
  //   socialIcon: "#FAE588",
  // },
  // {
  //   name: "Azure Sky",
  //   background: "#0c4a6e",
  //   button: { background: "#38bdf8", text: "#E3F6FD" },
  //   text: "#E3F6FD", // ice blue
  //   socialIcon: "#E3F6FD",
  // },

  // {
  //   name: "Rose Gold",
  //   background: "#78350f",
  //   button: { background: "#f59e0b", text: "#FBEAEA" },
  //   text: "#FBEAEA", // light blush
  //   socialIcon: "#FBEAEA",
  // },

  // ── Single-tones ──
  // {
  //   name: "Sage",
  //   background: "#E4EDEA",
  //   button: { background: "#1E4943", text: "#61847E" },
  //   text: "#61847E",
  // },
  // {
  //   name: "Lavender",
  //   background: "#F2ECF8",
  //   button: { background: "#2A1F3D", text: "#938F9D" },
  //   text: "#938F9D",
  // },
  // {
  //   name: "Matcha",
  //   background: "#ECF3E3",
  //   button: { background: "#1A3D2A", text: "#6F8E5C" },
  //   text: "#6F8E5C",
  // },
  // {
  //   name: "Forest",
  //   background: "#E8F0EB",
  //   button: { background: "#25533F", text: "#5E7D6F" },
  //   text: "#5E7D6F",
  // },
  // {
  //   name: "Blueberry",
  //   background: "#E8F1F7",
  //   button: { background: "#1A3D5C", text: "#6F8FA8" },
  //   text: "#6F8FA8",
  // },
  // {
  //   name: "Bubblegum",
  //   background: "#FDE8F0",
  //   button: { background: "#4F1F38", text: "#B57E96" },
  //   text: "#B57E96",
  // },
  // {
  //   name: "Wine",
  //   background: "#F3E8EC",
  //   button: { background: "#6D1F42", text: "#9B7584" },
  //   text: "#9B7584",
  // },
  // {
  //   name: "Lilacs",
  //   background: "#F4EDF6",
  //   button: { background: "#3D1F45", text: "#998696" },
  //   text: "#998696",
  // },
  // {
  //   name: "Orchid",
  //   background: "#F5C7F5",
  //   button: { background: "#46003E", text: "#A088A0" },
  //   text: "#A088A0",
  // },
  // {
  //   name: "Sky",
  //   background: "#EDF3F9",
  //   button: { background: "#1F3A52", text: "#758CA0" },
  //   text: "#758CA0",
  // },
  // {
  //   name: "Coral",
  //   background: "#FCEADE",
  //   button: { background: "#4D1E0D", text: "#B5826D" },
  //   text: "#B5826D",
  // },
  // {
  //   name: "Olive",
  //   background: "#F2F3E4",
  //   button: { background: "#2F3920", text: "#8B8D72" },
  //   text: "#8B8D72",
  // },

  // // ── Neutrals ──
  // {
  //   name: "Dark",
  //   background: "#181818",
  //   button: { background: "#F0F0F0", text: "#8A8A8A" },
  //   text: "#8A8A8A",
  // },
  // {
  //   name: "Bronze",
  //   background: "#F5EEE2",
  //   button: { background: "#3A2F1F", text: "#A89478" },
  //   text: "#A89478",
  // },
  // {
  //   name: "Tobacco",
  //   background: "#1F140A",
  //   button: { background: "#E6D5B8", text: "#8A7560" },
  //   text: "#8A7560",
  // },
  // {
  //   name: "Coffee + Cream",
  //   background: "#21190E",
  //   button: { background: "#F4ECD8", text: "#8A7E62" },
  //   text: "#8A7E62",
  // },
  // {
  //   name: "Cream + Coffee",
  //   background: "#EFE8DE",
  //   button: { background: "#1A1410", text: "#8A7E62" },
  //   text: "#8A7E62",
  // },

  // // ── Two-tones · Bold ──
  // {
  //   name: "Honey + Tangerine",
  //   background: "#EFCE7B",
  //   button: { background: "#C24818", text: "#C49B7E" },
  //   text: "#C49B7E",
  // },
  // {
  //   name: "Wheat + Crimson",
  //   background: "#F8EBD8",
  //   button: { background: "#B02818", text: "#B58E76" },
  //   text: "#B58E76",
  // },
  // {
  //   name: "Cream + Cobalt",
  //   background: "#F8EBD8",
  //   button: { background: "#024CA1", text: "#B5A78E" },
  //   text: "#B5A78E",
  // },
  // {
  //   name: "Pool + Cherry",
  //   background: "#D5E8EF",
  //   button: { background: "#E94A40", text: "#8FAAB3" },
  //   text: "#8FAAB3",
  // },
  // {
  //   name: "Lime + Ruby",
  //   background: "#DAFEB2",
  //   button: { background: "#B82210", text: "#98B589" },
  //   text: "#98B589",
  // },
  // {
  //   name: "Periwinkle + Scarlet",
  //   background: "#C7D1F5",
  //   button: { background: "#D80000", text: "#888EA8" },
  //   text: "#888EA8",
  // },
  // {
  //   name: "Butter + Emerald",
  //   background: "#FCEBA8",
  //   button: { background: "#037053", text: "#B5A06F" },
  //   text: "#B5A06F",
  // },
  {
    name: "Default",
    background: "#F2F1EE",
    card_style: "#E7E6E2",
    button: { background: "#111111", text: "#8A8A86", border: "" },
    text: "#8A8A86",
    socialIcon: "#111111",
  },
  //odler
  // {
  //   name: "Default",
  //   background: "#fff",
  //   button: { background: "#e6e7eb", text: "#000000" },
  //   text: "#000000",
  //   socialIcon: "#000000",
  // },
  // {
  //   name: "Sage",
  //   background: "#E4EDEA",
  //   card_style: "#F0F5F3",
  //   button: { background: "#1E4943", text: "#61847E" },
  //   text: "#61847E",
  //   quaternary: "#D8E6E2",
  // },
  {
    name: "Lavender",
    background: "#E9E6F4",
    card_style: "#DDD9EE",
    button: { background: "#2E2A44", text: "#8B87A6" },
    text: "#8B87A6",
  },
  {
    name: "Matcha",
    background: "#EAF0E2",
    card_style: "#DCE6D0",
    button: { background: "#25402A", text: "#7E9478" },
    text: "#7E9478",
  },
  // {
  //   name: "Forest",
  //   background: "#E8F0EB",
  //   card_style: "#F2F7F4",
  //   button: { background: "#25533F", text: "#5E7D6F" },
  //   text: "#5E7D6F",
  //   quaternary: "#D5E4DD",
  // },
  
  {
    name: "Terracotta",
    background: "#F6E9E1",
    card_style: "#EDDCCF",
    button: { background: "#6E3A22", text: "#B08A72" },
    text: "#B08A72",
  },
  {
    name: "Blueberry",
    background: "#E4EBF3",
    card_style: "#D6E1ED",
    button: { background: "#1F3A5C", text: "#7A93B0" },
    text: "#7A93B0",
  },
  {
    name: "Pink",
    background: "#F8E4EC",
    card_style: "#F1D5E1",
    button: { background: "#6E2340", text: "#C08BA2" },
    text: "#C08BA2",
  },
  // {
  //   name: "Bubblegum",
  //   background: "#FDE8F0",
  //   card_style: "#FEF2F7",
  //   button: { background: "#4F1F38", text: "#B57E96" },
  //   text: "#B57E96",
  // },
  // {
  //   name: "Wine",
  //   background: "#F3E8EC",
  //   card_style: "#F8F2F5",
  //   button: { background: "#6D1F42", text: "#9B7584" },
  //   text: "#9B7584",
  // },
  // {
  //   name: "Lilacs",
  //   background: "#F4EDF6",
  //   card_style: "#F9F5FA",
  //   button: { background: "#3D1F45", text: "#998696" },
  //   text: "#998696",
  // },
  // {
  //   name: "Orchid",
  //   background: "#F5C7F5",
  //   card_style: "#FAE0FA",
  //   button: { background: "#46003E", text: "#A088A0" },
  //   text: "#A088A0",
  // },
  // {
  //   name: "Sky",
  //   background: "#EDF3F9",
  //   card_style: "#F5F8FC",
  //   button: { background: "#1F3A52", text: "#758CA0" },
  //   text: "#758CA0",
  // },
  // {
  //   name: "Coral",
  //   background: "#FCEADE",
  //   card_style: "#FDF3ED",
  //   button: { background: "#4D1E0D", text: "#B5826D" },
  //   text: "#B5826D",
  // },
  {
    name: "Olive",
    background: "#EEEFE2",
    card_style: "#E2E4D0",
    button: { background: "#3E4428", text: "#93987B" },
    text: "#93987B",
  },

  // ── Neutrals ──
  {
    name: "Dark",
    background: "#1C1C1C",
    card_style: "#2C2C2C",
    button: { background: "#F2F1EE", text: "#9A9A96" },
    text: "#9A9A96",
  },
  {
    name: "Bronze",
    background: "#EFE7DA",
    card_style: "#E4D8C5",
    button: { background: "#4A3A26", text: "#A08D72" },
    text: "#A08D72",
  },
  {
    name: "Tobacco",
    background: "#EAE2D4",
    card_style: "#DDD1BE",
    button: { background: "#2E2418", text: "#8E7C62" },
    text: "#8E7C62",
  },
  // {
  //   name: "Coffee + Cream",
  //   background: "#21190E",
  //   card_style: "#85807A",
  //   button: { background: "#F4ECD8", text: "#8A7E62" },
  //   text: "#8A7E62",
  // },
  {
    name: "Cream + Charcoal",
    background: "#F5F0E4",
    card_style: "#EAE3D2",
    button: { background: "#26262A", text: "#9A9488" },
    text: "#9A9488",
  },
  {
    name: "Grey",
    background: "#EDEDED",
    card_style: "#E0E0E0",
    button: { background: "#333333", text: "#9C9C9C" },
    text: "#9C9C9C",
  },

  // ── Two-tones · Bold ──
  {
    name: "Honey + Tangerine",
    background: "#F4E3B2",
    card_style: "#EFD996",
    button: { background: "#C4501E", text: "#B49A5E" },
    text: "#B49A5E",
  },
  // {
  //   name: "Wheat + Crimson",
  //   background: "#F8EBD8",
  //   card_style: "#FBF4EA",
  //   button: { background: "#B02818", text: "#B58E76" },
  //   text: "#B58E76",
  // },
  {
    name: "Cream + Cobalt",
    background: "#F1EADB",
    card_style: "#E7DEC9",
    button: { background: "#1F41B5", text: "#A79E8C" },
    text: "#A79E8C",
  },
  {
    name: "Pool + Cherry",
    background: "#CFE3EA",
    card_style: "#BFD8E1",
    button: { background: "#D6402B", text: "#8FA9B2" },
    text: "#8FA9B2",
  },
  {
    name: "Lime + Ruby",
    background: "#DFF3C4",
    card_style: "#D2ECAF",
    button: { background: "#B22B2B", text: "#9BB07E" },
    text: "#9BB07E",
  },
  {
    name: "Periwinkle + Red",
    background: "#DCDCF6",
    card_style: "#CFCFF0",
    button: { background: "#D42B1E", text: "#9C9CBE" },
    text: "#9C9CBE",
  },
  {
    name: "Butter + Evergreen",
    background: "#F2E9B8",
    card_style: "#ECE09C",
    button: { background: "#20522E", text: "#B0A878" },
    text: "#B0A878",
  },
  {
    name: "Cobalt",
    background: "#D8E6F8",
    card_style: "#C8DBF4",
    button: { background: "#2A6BD4", text: "#8FA6C6" },
    text: "#8FA6C6",
  },
  {
    name: "Lime + Pine",
    background: "#E4F0A6",
    card_style: "#DAEA8C",
    button: { background: "#274A22", text: "#9BA86E" },
    text: "#9BA86E",
  },
  {
    name: "Hot Pink + Plum",
    background: "#F7A8CB",
    card_style: "#F390BD",
    button: { background: "#3E1230", text: "#C97FA4" },
    text: "#C97FA4",
  },
  {
    name: "name",
    background: "primary",
    card_style: "fourth",
    button: { background: "secondary", text: "tertiary" },
    text: "tertiary",
  },
];
